module.exports = __webpack_public_path__ + "img/yota-ipad-1.cb3ef53e.png";